import { Component, OnInit } from "@angular/core";
import { map, take, finalize } from "rxjs/operators";
import {
  NotificationType,
  DashboardnotificationsComponent,
} from "../dashboardnotifications/dashboardnotifications.component";
import { ModalService } from "src/app/core/modalservice/modal.service";
import { UserFacadeService } from "src/app/core/facades/userfacade/userfacade.service";
import { NgIf } from "@angular/common";
import { MatProgressSpinner } from "@angular/material/progress-spinner";
import { RouterLink } from "@angular/router";
import { TooltipDirective } from "ngx-bootstrap/tooltip";
import { TourAnchorMatMenuDirective } from "ngx-ui-tour-md-menu";
import { SimpleUpdateNotificationTableComponent } from "../simpleTables/simple-update-notification-table/simple-update-notification-table.component";
import { TranslatePipe } from "@ngx-translate/core";
import { MatDialog } from "@angular/material/dialog";
import { TourModalComponent } from "../tour-modal/tour-modal.component";
import { UnleashService } from "src/app/core/api_services/unleash.service";

@Component({
  selector: "app-user-dashboard",
  templateUrl: "./user-dashboard.component.html",
  styleUrls: ["./user-dashboard.component.scss"],
  imports: [
    NgIf,
    MatProgressSpinner,
    DashboardnotificationsComponent,
    RouterLink,
    TooltipDirective,
    TourAnchorMatMenuDirective,
    SimpleUpdateNotificationTableComponent,
    TranslatePipe,
  ],
})
export class UserDashboardComponent implements OnInit {
  isloading = true;
  count = {
    onlineDevices: 0,
    offlineDevices: 0,
    licenses: 0,
    validLicemses: 0,
    expiredInTenDaysLicenses: 0,
    expiredLicenses: 0,
    invoices: 0,
    resources: 0,
  };
  message = [];

  constructor(
    private userFacadeService: UserFacadeService,
    private modalService: ModalService,
    private dialog: MatDialog,
    private unleashService: UnleashService,
  ) {}

  ngOnInit() {
    this.getCount();
    this.checkOrgData();
    if (TourModalComponent.shouldShowTourModal()) {
      if (this.unleashService.isEnabled("portal.onboarding-bookable-resource.tour.1")) {
        this.openTourModal();
      }
    }
  }

  openTourModal(): void {
    this.dialog.open(TourModalComponent, {
      width: "90vw",
      maxWidth: "700px",
      disableClose: false,
      autoFocus: true,
      hasBackdrop: true,
    });
  }

  getCount() {
    this.userFacadeService
      .getOrganisationSummary()
      .pipe(
        take(1),
        finalize(() => (this.isloading = false)),
      )
      .subscribe((s) => {
        this.count.resources = s.resources;
        this.count.onlineDevices = s.onlineDevices;
        this.count.offlineDevices = s.offlineDevices;
        // if (this.count.resources <= 0) {
        //   this.message.push(NotificationType.noResource);

        //   if (s.connectors > 0) {
        //     if (
        //       this.userFacadeService.user.getValue().roles.includes(RoleType.GlobalAdmin)
        //     ) {
        //       this.resourceTour.startTour();
        //     }
        //   }
        // }
        this.count.licenses = s.licenses;
        this.count.validLicemses = s.validLicemses;
        this.count.expiredInTenDaysLicenses = s.expiredInTenDaysLicenses;
        this.count.expiredLicenses = s.expiredLicenses;
        this.count.invoices = s.invoices;
        // if (this.userFacadeService.user.getValue().roles.includes(RoleType.GlobalAdmin)) {
        //   if (s.connectors === 0) {
        //     const stepTour = localStorage.getItem("step");
        //     if (!stepTour || (stepTour !== "3" && stepTour !== "2" && stepTour !== "4")) {
        //       this.modalService.welcomeModal().then((x) => {
        //         if (x) {
        //           this.connectorTour.startTour();
        //           localStorage.setItem("step", "1");
        //         }
        //       });
        //     }
        //   }
        // }
      });
  }

  checkOrgData() {
    this.userFacadeService.organizationInformation
      .pipe(
        take(1),
        map((x) => {
          if (x.phoneNumber == null) {
            this.message.push(NotificationType.noOrgData);
          }
        }),
      )
      .subscribe();
  }
}
